import { render, staticRenderFns } from "./PT260FAQContentParts.vue?vue&type=template&id=210e2c49&"
import script from "./PT260FAQContentParts.vue?vue&type=script&lang=js&"
export * from "./PT260FAQContentParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports